import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { consumeAuthCallback } from './auth/callback.js';
import { LocaleProvider } from './i18n/LocaleProvider.js';
import './styles.css';

/**
 * **`StrictMode` 를 쓰지 않는다.** 개발 모드에서 효과를 두 번 실행하므로 `HlsPlayerAdapter` 가
 * 두 벌 만들어지고 `<video>` 가 네 개가 된다. 디코더가 둘로 나뉜 상태의 T_freeze 는
 * 아무 의미가 없고, 이 앱의 존재 이유 중 하나가 그 수치를 재는 것이다.
 *
 * **흡수된 모바일 웹은 켜고 있었다** (T7 — 정리를 빠뜨리면 개발 모드에서 즉시 드러나므로).
 * 통합으로 두 화면이 한 트리에 들어온 이상 둘 다 만족시킬 수 없고, 재는 쪽이 이긴다.
 * 잃는 것은 없다 — 그때 `StrictMode` 가 잡아낸 결함(기동 이중 실행)의 대책은 이중 실행을
 * 견디는 **단일 비행**(`useTv2m.ts` 의 `startupPromise`)이지 `StrictMode` 자체가 아니고,
 * 그 장치는 그대로 남아 있다.
 *
 * **`LocaleProvider` 가 최상위다** (절대 규칙 25). 재생 트리보다 위에 있어야 언어를 바꿔도
 * `<video>` 가 다시 마운트되지 않는다 — 트리 안에 두거나 언어로 `key` 를 갈면 **영상이
 * 처음으로 돌아간다.** 이 한 줄의 위치가 그 규칙의 전부다.
 */
/*
 * **GIS redirect 의 착지점을 React 보다 먼저 소비한다** (v17 R9 · `docs/40` D12).
 *
 * 여기서 하는 일은 저장소 쓰기와 이동뿐이라 화면이 필요 없고, **그린 뒤에 하면 그 한
 * 프레임이 시청 화면**이다 — 토큰을 들고 방송이 잠깐 뜬다. 그리고 곧 페이지를 옮기므로
 * 마운트 자체가 낭비다.
 */
if (consumeAuthCallback()) {
  // 이동 중이다. 트리를 세우지 않는다.
} else {
  mount();
}

function mount(): void {
  const root = document.getElementById('root');
  if (root === null) throw new Error('#root 를 찾을 수 없다.');
  createRoot(root).render(
    <LocaleProvider>
      <App />
    </LocaleProvider>,
  );
}
